<template>
  <tour :steps="tourSteps">

    <EstadoPedidoModal
      :modalShow="showEstadoPedidoModal"
      :state="estadoPedido"
      @close="handleEstadoPedido"
    />

  <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
    <ConfirmLancarPedidoModal
        :modalShow="modalPedido.showModal"
        :typeModal="modalPedido.typeModal"
        :modalName="'lancarRealizarNovoPedido'"
        @confirmed="saveOrder"
        @canceled="() => modalPedido.showModal = false"
        @confirmedTrhowNewOrder="confirmedTrhowNewOrder"
    />

    <PendenciaModal :showModal="modalPendencia.showModal" :titleText="modalPendencia.titleText"
      :infoText="modalPendencia.infoText" @confim-action="handleConfirmPendencia"
      @reject-action="handleRejectPendencia" />
      <page-header :screenName="screenName" :linkItems="linkItems" />
      <section class="order-details" v-if="!showLoading && populated" id="adesao">

      <b-row v-if="populated">
        <b-col cols="12" xl="9" md="8">
          <b-card no-body class="invoice-preview-card">
            <b-card-body class="order-details-padding pb-0">

              <b-row class="titles" v-if="!modoVisualizacao">
                <b-col cols="12" class="mb-2">
                  <b-badge pill variant="light-secondary"> Rascunho </b-badge>
                </b-col>
              </b-row>

              <div class="logo-wrapper mb-3">
                <img :src="logo" alt="VacinaSESI" class="d-inline-block float-left" />

                <h2 v-if="modoVisualizacao" v-text="screenName" class="d-inline-block float-right"></h2>
              </div>
              <!-- countdown-->
              <div class="d-block mb-3" v-if="modoCriacao">
                <b-alert variant="warning" show>
                  <h4 class="alert-heading">
                    Atenção! Ao final do tempo abaixo ou ao clicar em Editar
                    Pedido, as informações da sua adesão serão perdidas.
                    Finalize a adesão ou crie uma nova para alterar valores.
                  </h4>
                  <div class="alert-body countdown">
                    Você tem <strong>{{ displayTime }}</strong> para finalizar
                    sua adesão.
                  </div>
                </b-alert>
              </div>

              <div class="
                    d-flex
                    justify-content-between
                    flex-md-row flex-column
                    invoice-spacing
                    mt-0
                  ">
                <div v-if="responsible != null" class="d-inline-block float-left">
                  <p class="card-text mb-25 mt-2">
                    <strong>{{ campaignDescription }}</strong>
                  </p>
                </div>

                <div v-if="modoVisualizacao" class="d-inline-block float-right mt-2">
                  <p class="m-0 text-right">
                    Data da realização: <strong>{{ order.dateAdhesion }}</strong>
                  </p>
                </div>
              </div>
              <div class="d-block mt-2" v-if="canceledAdhesion">
                <b-alert class="p-1" variant="danger" show>
                  <strong>Atenção! Esta é uma adesão cancelada.</strong>
                </b-alert>
              </div>
            </b-card-body>
            <b-card-body v-if="order.sesi_responsavel != null" class="order-details-padding pt-0 pb-0">
              <div class="mb-2">
                <p class="card-text mb-25 mt-3">
                  {{ order.sesi_responsavel.descricao }}
                </p>
                <p class="card-text mb-25 mt-2">
                  {{adhesion ? adhesion.empresa_endereco.descricao : company.descricao}}
                </p>
                <p class="card-text mb-25">
                  {{adhesion ? adhesion.empresa_endereco.logradouro : company.logradouro}}, n° {{adhesion ? adhesion.empresa_endereco.numero : company.numero_empresa}}, {{ adhesion ? adhesion.cidade.nome : company.cidade}},
                  {{adhesion ? adhesion.cidade.uf : company.uf}}, {{adhesion? adhesion.cep :    company.cep | VMask("#####-###")}}

                </p>
                <p class="card-text mb-25" v-if="order.sesi_responsavel.contato != null">
                  {{ order.sesi_responsavel.contato.email_responsavel }}
                </p>
              </div>
            </b-card-body>

            <hr class="mx-2"/>
            <b-card-body v-if="company != null" class="order-details-padding pt-0 pb-0 mt-2">
              <div class="mb-2">

                <h6 v-if="company.documento.length == 14">CNPJ {{ company.documento | formataCpfCnpj }}</h6>
                <h6 v-else>CPF {{ company.documento | formataCpfCnpj }}</h6>
                <p class="card-text mb-1">
                  {{ company.nome_empresa }}
                </p>

                <h6 v-if="company.empresa_endereco">{{adhesion ? adhesion.empresa_endereco.descricao : company.descricao}}</h6>
                <p class="card-text mb-25" v-if="adhesion">
                  {{ adhesion.logradouro }}, {{ adhesion.bairro }}
                </p>
                <p class="card-text mb-25" v-if="adhesion && adhesion.cidade">
                  {{ adhesion.cidade.nome }}/{{ adhesion.cidade.uf }}
                </p>
                <p class="card-text mb-25" v-if="address">
                  {{ address.nome }}/{{ address.uf }}
                </p>
              </div>
            </b-card-body>

            <b-card-body v-if="company != null" class="order-details-padding pt-0">
              <div class="mb-4">
                <h6>Aos cuidados:</h6>
                <p class="mb-25 font-weight-bold" v-if="company.empresa_contato != null">
                  {{ contact_adress ? contact_adress.nome : company.responsavel }}
                </p>
                <p class="card-text mb-25" v-if="company.empresa_contato != null">
                  {{ contact_adress ? contact_adress.email : company.email }}
                </p>
                <p class="card-text mb-25" v-if="company.empresa_contato != null">
                  {{ telefoneFormatado }}
                </p>
              </div>
            </b-card-body>

            <div v-if="doses != null">
              <ViewPriceRangePurchase class="mb-2" v-if="priceRangePricing.length"
                :doses="priceRangePricing"
                :info="order"
                :getSumTotalQtd="getSumTotalQtd"
                :getTotals="getTotals"
              />
              <ManualOrderDetailsTable v-if="manualPricing.length" :doses="manualPricing" />
            </div>

            <b-card-body class="order-details-padding pb-0 mb-4">
              <b-card-text class="mb-25 d-flex align-items-center">
                <strong class="mr-2">
                  Atenção!
                </strong>
                <span>
                  Os valores acima podem sofrer alterações, de acordo com as condições estabelecidas nas regras de contratação.
                  Consulte o termo de adesão para mais detalhes e, em caso de dúvidas, entre em contato com o SESI.
                </span>
              </b-card-text>
              <b-card-text class="mb-25">
              </b-card-text>
            </b-card-body>

            <b-card-footer class="order-details-padding pt-0">
              <div class="order-details-footer">
                <div class="order-details-emit">
                  <p>
                    <span class="order-details-footer-title">Pedido realizado por:</span>
                    {{ issuedBy }}
                  </p>
                </div>
                <div class="order-details-canceled-container mb-2" v-if="canceledAdhesion">
                    <p>
                      <span class="order-details-footer-title">Adesão cancelada por:</span>
                      {{ canceledBy }}
                    </p>
                    <p>
                      <span class="order-details-footer-title">Data/Hora do cancelamento:</span>
                      {{ canceledDate }}
                    </p>
                  </div>

                <div>
                  <h6 class="order-details-footer-title">Observações</h6>
                  <p v-text="order.observation" class="mb-3"></p>
                  <h6 v-if="adhesionNumber" class="order-details-footer-title">Este pedido refere-se a adesão #{{
                    adhesionNumber }}</h6>
                </div>
              </div>
            </b-card-footer>
          </b-card>
        </b-col>

        <b-col cols="12" md="4" xl="3" class="invoice-actions">
          <b-card class="order-details-pd-btn" v-if="modoCriacao">
            <button type="button" class="btn custom-outline-blue custom-blue-shadow mb-75 w-100"
              @click="editOrderOrBack()">
              Editar o Pedido
            </button>

            <button type="button" class="btn custom-outline-blue custom-blue-shadow mb-75 w-100"
            @click.prevent="setUrlBlobContract">
              Visualizar o Termo
            </button>

            <!-- Button: Download -->
            <b-button
              variant="custom-blue"
              @click.prevent="openModalPedido"
              :disabled="getDesabilitarEnvio"
              block
            >
              <span class="align-middle">Finalizar Adesão</span>
              <span v-if="loadingSaving" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>
            </b-button>
          </b-card>
          <b-card class="order-details-pd-btn" v-if="modoVisualizacao">
            <b-button variant="btn custom-outline-blue" v-if="term" block @click.prevent="visualizarTermo">
              Visualizar termo
            </b-button>
            <b-button variant="outline-danger" class="custom-outline-red btn" block @click="openModalPendencia()" v-if="canCancelAdhesion && !canceledAdhesion">
              Cancelar adesão
            </b-button>
            <b-button variant="custom-blue" block @click="editOrderOrBack()">
              Voltar
            </b-button>
          </b-card>
        </b-col>
      </b-row>
      <NotificacoesModal
          :previues="previues"
          :redirectProp="false"
          @showRatingModal="() => showModalNps = true"
      />
      <PdfAdesaoModal :modalShow="showModal.show" :modoCriacao="modoCriacao" :pdf="pdf" @fechar="fecharModal" @aceitouTermo="aceitouTermo" />
      <NpsRatingModal
      :modalShow="showModalNps"
      originRating="ADESAO"
      :additionalParams="additionalParamsNps"
      @hideModal="redirectAfterHideModalRating"/>
    </section>
  </b-overlay>
  </tour>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardFooter,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BFormCheckbox,
  BOverlay, BBadge,
} from "bootstrap-vue";
import { format } from "@/helpers/money";
import logo from "@/assets/custom-images/vacina-sesi-logo-azul.svg";
import Ripple from "vue-ripple-directive";
import {
  AdesaoSetValidacaoDosesEmpresa,
  AdesaoGetChooseOrder,
  AdesaoGetChooseCompany,
  AdesaoGetChooseCampaign,
  AdesaoSetChooseCampaign,
  AdesaoSetChooseCompany,
  AdesaoSalvarPedidoRascunho,
  AdesaoSetChooseOrder,
  AdesaoGetInformacoesPersistencia
} from "@/views/custom-pages/adesao/Purchase/adesaoHelpers.js";
import { getUserData } from "@/auth/utils";
import moment from "moment";
import PageHeader from "@/views/components/custom/page-header/PageHeader.vue";
import NotificacoesModal from "@/views/custom-pages/adesao/components/NotificacoesModal/NotificacoesModal.vue";
import platform from "platform";
import $store from "@/store";
import PdfAdesaoModal from "@/views/custom-pages/adesao/components/PdfAdesaoModal/PdfAdesaoModal.vue";
import PendenciaModal from '@/views/components/custom/modals/adesao/PendenciaModal.vue';
import ConfirmLancarPedidoModal from '@/views/components/custom/modals/ConfirmLancarPedidoModal.vue';
import { actions, subjects } from "@/libs/acl/rules";
import detailsPurchaseMixin from "../../tour-mixins/detailsPurchaseMixin";
import EstadoPedidoModal from "../../components/EstadoPedidoModal/EstadoPedidoModal.vue";
import NpsRatingModal from "../../components/NpsRatingModal/NpsRatingModal.vue";
import ViewPriceRangePurchase from '@/views/custom-pages/adhesion-price-range/view/ViewPriceRangePurchase.vue'
import ManualOrderDetailsTable from "@/views/custom-pages/adesao/Details/View/ManualOrderDetailsTable.vue";

export default {
  title: "Ver Adesão Detalhes",

  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BBadge,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardFooter,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    BFormCheckbox,
    PageHeader,
    NotificacoesModal,
    PdfAdesaoModal,
    BOverlay,
    PendenciaModal,
    ConfirmLancarPedidoModal,
    ViewPriceRangePurchase,
    ManualOrderDetailsTable,
    EstadoPedidoModal,
    NpsRatingModal
  },
  mixins: [detailsPurchaseMixin],
  data() {
    return {
      lotePromocional: 1,
      lotePadrao: 2,
      showModal: {
        show: false,
      },
      modalPendencia: {
        showModal: false,
        titleText: "Você confirma o cancelamento?",
        infoText: 'Ao clicar em "Sim", você estará cancelando esta adesão. As doses aqui não estarão mais reservadas para esta empresa e poderão ser utilizadas em novas adesões. Esta ação não pode ser desfeita.',
      },

      pdf: {
        blob: null,
        name: null,
      },
      logo,
      adhesionNumber: null,
      showLoading: true,
      populated: false,
      readandAcceptTerm: false,
      adhesionHasError: false,
      urlContract: null,
      screenName: "Aderir Campanha",
      fields: [
        { key: "vacina_nome_tecnico", label: "VACINA | CATEGORIA", class: "text-left" },
        { key: "id_incentivo", label: "LOTE", class: this.isPerfilAdminEmpresa() ?  "d-none" : "text-center"  },
        { key: "custo_unitario", label: "VALOR DA DOSE", class: "text-center" },
        { key: "qtd_distribuida", label: "QTD DE DOSES", class: "text-center" },
        { key: "valor", label: "VALOR TOTAL", class: "text-center" },
      ],
      showModalNps: false,
      clockCount: 0,
      count: 0,
      delayRender: 2000,
      termo: [],

      linkItems: [
        {
          name: "Adesão",
          routeName: "purchase",
        },
        {
          name: "Aderir Campanha",
          routeName: "",
        },
        {
          name: "Ver Detalhes",
          active: true,
        },
      ],

      modoCriacao: true,
      modoVisualizacao: false,
      timeLeft: null,
      dataAdesaoGetValidacaoDosesEmpresa: {},
      canceledAdhesion: false,
      canCancelAdhesion: false,
      modalPedido:
        {
          showModal: false,
          typeModal: 'info'
        },
      loadingSaving: false,
      processando: false,
      campaign: null,
      companyOrder: null,
      previues: false,
      estadoPedido: null,
      showEstadoPedidoModal: false,
      tourSteps: [],
      idAdhesionParam: null
    };
  },

  beforeMount() {
    let modoVisualizacao = this.$route.params.modoVisualizacao ?? this.$route.name == "visualizar-adesao-empresa";
    this.modoCriacao = !modoVisualizacao;
    this.modoVisualizacao = modoVisualizacao;
    this.campaign = AdesaoGetChooseCampaign()
    this.companyOrder = AdesaoGetChooseCompany()
    this.canCancelAdhesion = this.verifyPermissions(actions.INSERIR)

    if(this.loadData){
      this.beforeMountInit();
    }
  },

  created() {
    this.startClock();
  },

  methods: {
    isPerfilAdminEmpresa() {
      return this.$store.state.sessions.userData.perfis[0].chave === 'ADMIN_EMPRESA';
    },
    beforeMountInit(){
      if (this.modoVisualizacao) {
        this.setAdesaoSetValidacaoDosesEmpresa();
      } else {
        this.dadosPedidoRascunho(this.$route.params.idPedido);
      }
    },
    async dadosPedidoRascunho(idPedido) {
      await this.$http
          .get(this.$api.pedidoRascunhoPrecificacoes(idPedido))
          .then((response) => {
            this.order = response.data;

            this.estadoPedido = this.order.estado;

            if (this.estadoPedido !== "ativo" && !this.modoVisualizacao) {
              this.showEstadoPedidoModal = true;
              return;
            }

            this.setUrlBlobContract();
            this.populated = true;
            this.setTimers();
          })
          .catch(() => {
            this.estadoPedido = "removido";
            this.showEstadoPedidoModal = true;
            this.populated = true;
          });
    },
    async saveOrder() {
      this.loadingSaving = true;
      this.openModalPedido();
      this.setTermo();
      $store.dispatch("adesaoState/setTermo", this.termo);

      AdesaoSetChooseOrder({ id_pedido: this.$route.params.idPedido }, false)

      await AdesaoSalvarPedidoRascunho(false, true, true);
      this.modalPedido.showModal = false;
      this.loadingSaving = false;
    },
    async confirmedTrhowNewOrder() {
      await this.saveOrder()
      AdesaoSetChooseCampaign(this.campaign)
      AdesaoSetChooseCompany(this.companyOrder)
      this.campaign = null
      this.unit = null
      this.previues = !this.previues;
      this.previues = true;
    },
    editOrderOrBack() {
      let name = this.modoCriacao ? "purchase" : "acceptances";
      let params = this.modoCriacao ? { idPedido: this.$route.params.idPedido } : {};

      this.$router.push({ name, params }).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
    setTermo() {
      const items = {
        so: platform.os.family,
        versao_so: platform.version,
      };
      return this.termo.push(items);
    },
    startClock: function () {
      this.countdownID = setInterval(this.countDown, 1000);
    },
    countDown: function () {
      this.count--;
      if (this.count <= 0) {
        this.stopClock();
      }
    },
    stopClock: function () {
      clearInterval(this.countdownID);
      this.countdownID = undefined;
    },
    setTimers() {
      this.showLoading = true;
      let timeLeft = 0;

      if (this.timeLeft != null && this.timeLeft > 0) {
        timeLeft = this.timeLeft;
      } else {
        timeLeft = parseInt(
          (moment(this.order.expira_em,'YYYY-MM-DD HH:mm:ss.SSS Z').valueOf() - moment().valueOf()) /
          1000
        );
      }

      this.clockCount = timeLeft > 0 ? timeLeft : 0;
      this.count = timeLeft > 0 ? timeLeft : 0;

      this.showLoading = !this.showLoading;
    },
    modalError(text, title = "Erro ao consultar a adesão") {
      this.$swal({
        title,
        text,
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Ok",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      }).then((result) => {
        if (result.value) {
          this.editOrderOrBack();
        }
      });
    },
    async setAdesaoSetValidacaoDosesEmpresa() {
      let chooseOrder = AdesaoGetChooseOrder(),
        rota = this.$api.pedidoAdesaoPrecificacoes(chooseOrder.id_pedido),
        params = {
          id_empresa: chooseOrder.id_empresa,
          id_adesao: chooseOrder.id_adesao,
          id_campanha: AdesaoGetChooseCampaign().id_campanha
        };

      await this.$http
        .get(rota, { params })
        .then(({ data }) => {
          data.observation = this.getObservation(data);
          data.dateAdhesion = this.formatDateAdhesion(data.data_prevista);

          if(data.adesao.situacao == 'Cancelado') {
            this.canceledAdhesion = true
          }

          AdesaoSetValidacaoDosesEmpresa(data);
          this.order = data;

          this.adhesionNumber = chooseOrder.id_adesao;
          this.setScreenNameAdhesion(`Pedido #${chooseOrder.numero_pedido}`);

          this.populated = true;
          this.timeLeft = 0;
          this.setTimers();
        })
        .catch(() => {
          this.modalError("Pedido não encontrado!");
        });
    },
    setUrlBlobContract() {
      this.$http
        .get(this.$api.getContract(AdesaoGetChooseCampaign().id_campanha), {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });

          this.pdf.blob = URL.createObjectURL(blob);
          this.pdf.nome = response.headers["content-name-file"];
          this.openModal();
        })
        .catch(() => {
          this.adhesionHasError = true;
          this.$helpers.modalErroTermoDeAdesao();
        });
    },
    setScreenNameAdhesion(screenName) {
      this.screenName = screenName;
      this.linkItems = [
        { name: "Adesão", routeName: "acceptances" },
        { name: this.screenName, active: true },
      ];
    },
    formatDateAdhesion(date) {
      return moment(String(date)).format("DD/MM/YYYY");
    },
    getObservation(data) {
      return data.observacao != null && data.observacao.length > 0
        ? data.observacao
        : "---";
    },
    visualizarTermo() {
      const tipoTermo = this.order.termo.tipo;
      this.$http.get(this.$api.downloadAdhesionContract(AdesaoGetChooseOrder().id_campanha), {
        responseType: "blob",
        params: {
          tipo: tipoTermo,
          id_adesao: AdesaoGetChooseOrder().id_adesao
        }
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });

          this.pdf.blob = URL.createObjectURL(blob);
          this.pdf.nome = response.headers["content-name-file"];
          this.openModal();
        })
        .catch(() => {
          this.$helpers.modalErroServidorPadrao();
        });
    },

    openModal() {
      this.showModal.show = true;
    },

    fecharModal() {
      this.showModal.show = false;
    },

    aceitouTermo(){
      this.showModal.show = false;
      this.readandAcceptTerm = true
    },

    openModalPedido() {
      this.modalPedido.showModal = true;
    },
    redirectAceptances() {
      this.$router.push(
        {
          name: 'acceptances'
        }
      );
    },
    cancelAdhesion() {
      const parameters = {
        id_adesao: AdesaoGetChooseOrder().id_adesao
      }
      this.$http.put(this.$api.cancelAdhesion(), parameters)
        .then(() => {
            this.closeModalPendencia();
            this.redirectAceptances();
            this.processando = false
        })
        .catch(({ response: { data } }) => {
          this.closeModalPendencia();
          this.modalError(data.errors, 'Erro ao cancelar adesão');
          this.processando = false
        })
    },
    openModalPendencia() {
      this.modalPendencia.showModal = true;
    },
    closeModalPendencia() {
      this.modalPendencia.showModal = false;
    },
    handleConfirmPendencia() {
      if (!this.processando) {
        this.processando = true
        this.cancelAdhesion();
      }
    },
    handleRejectPendencia() {
      this.closeModalPendencia();
    },
     handleEstadoPedido() {
      this.showEstadoPedidoModal = false;
      this.$router.push({
        name: "acceptances",
        query: { tab: 'rascunhos' }
       });
    },
    verifyPermissions(action) {
      return this.$can(actions[action], subjects.ADESAO_SESI)
    },
    redirectAfterHideModalRating() {
      if(this.previues) {
        this.$router.push({ name: "join-campaign", query: {previues: true} });
      }else{
        this.$router.push({ name: "acceptances" });
      }
    }
  },

  computed: {
    campaignDescription() {
      const campaign = AdesaoGetChooseCampaign();
      return campaign?.descricao ?? campaign?.campanha_descricao;
    },
    getSumTotal() {
      if (!this.order.doses) return 0;

      return this.order.doses
        .map(dose => Number(dose.valor))
        .reduce((prev, curr) => prev + curr, 0);
    },
    getSumTotalQtd() {
      if (!this.order.doses) return 0;

      return this.order.doses
        .map((item) => item.qtd_distribuida)
        .reduce((prev, curr) => prev + curr, 0);
    },
    getTotals() {
      return format(this.getSumTotal);
    },
    getDesabilitarEnvio() {
      return this.adhesionHasError || !this.readandAcceptTerm || this.count <= 0 || this.saving;
    },
    displayTime: function () {
      let hours = Math.floor(this.count / 3600);
      let mins = Math.floor((this.count % 3600) / 60);
      let secs = this.count % 60;

      if (hours <= 0 && mins <= 0 && secs <= 0) {
        return "00:00:00";
      }

      const pad = (n) => (n < 10 ? "0" + n : n);

      return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
    },
    doses() {
      return this.order.doses;
    },
    manualPricing() {
      return this.order.doses.filter(dose => dose.id_desconto_progressivo_faixa === null)
    },
    priceRangePricing() {
      return this.order.doses.filter(dose => dose.id_desconto_progressivo_faixa !== null)
    },
    company() {
      return this.order.empresa;
    },
    responsible() {
      return this.order.sesi_responsavel;
    },
    responsibleEmail() {
      return this.responsible.contato != null && this.responsible.contato.email
        ? this.responsible.contato.email
        : null
    },
    adhesion() {
      return this.order.adesao;
    },
    term() {
      return this.order.termo;
    },
    address() {
      if (AdesaoGetChooseCompany()) {
        return AdesaoGetChooseCompany().endereco;
      }
    },
    contact_adress() {
      if (AdesaoGetChooseCompany()) {
        return AdesaoGetChooseCompany().contato;
      }

      if(this.order.empresa.empresa_endereco){
        let endereco = this.order.empresa.empresa_endereco.find(e =>
        e.id_cidade === this.order.adesao.id_cidade &&
        e.logradouro == this.order.adesao.logradouro &&
        e.bairro == this.order.adesao.bairro &&
        e.numero == this.order.adesao.numero &&
        e.cep == this.order.adesao.cep
        )
        return endereco ? endereco.contato : null
      }
    },
    issuedBy() {
      return this.order.processado_por != undefined
        ? this.dataAdesaoGetValidacaoDosesEmpresa.processado_por.nome
        : getUserData().fullName;
    },
    canceledBy() {
      return this.order.adesao.situacao == 'Cancelado'
        ? this.order.adesao.cancelado_por
        : null
    },
    canceledDate() {
      return  moment(String(this.order.adesao.data_alteracao)).format("DD/MM/YYYY HH:mm")
    },
    order: {
      get() {
        return this.dataAdesaoGetValidacaoDosesEmpresa;
      },
      set(field) {
        this.dataAdesaoGetValidacaoDosesEmpresa = field;
      },
    },
    telefoneFormatado() {
      const tel = this.contact_adress?.telefone || this.company.telefone_empresa;
      const phone = tel.replace(/\D/g, '');
      if (phone.length === 11) {
        return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else if (phone.length === 10) {
        return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else {
        return tel;
      }
    },
    additionalParamsNps() {
      if(AdesaoGetInformacoesPersistencia()?.idAdesao){
        this.idAdhesionParam = AdesaoGetInformacoesPersistencia()?.idAdesao
      }

      return {
        id_adesao: this.idAdhesionParam
      }
    }
  },
  watch: {
  '$route.params.idPedido': {
    immediate: false,
    handler() {
      this.adhesionNumber = null;

      const modoVisualizacaoParam = this.$route.params.modoVisualizacao;
      const modoVisualizacaoRota = this.$route.name === "visualizar-adesao-empresa";

      this.modoVisualizacao = modoVisualizacaoParam ?? modoVisualizacaoRota;
      this.modoCriacao = !this.modoVisualizacao;

      this.beforeMountInit();
    }
  }
}

};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "./../style.scss";

::v-deep .countdown strong {
  color: inherit;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.contract {
  a {
    color: #2772c0;
  }

  .custom-control-input:checked~.custom-control-label::before {
    border-color: #2772c0 !important;
    background-color: #2772c0 !important;
  }
}
.order-details-canceled-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

</style>
